import type { ReactElement } from "react";
import { useState } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IWebhookTableCellProps } from "app/pages/sales-intelligence/modules/signals-api-webhook/types/cell-props";

import InputCell from "../InputCell/InputCell";

import validateUrlString from "./utils/validate";

const URLInputCell = ({
    value,
    onChange,
    onErrorChange,
    index,
    name,
    ...props
}: IWebhookTableCellProps): ReactElement => {
    const [localValue, setLocalValue] = useState<string>(value);
    const [localError, setLocalError] = useState<string>("");
    const [validated, setValidated] = useState(false);

    const validate = (valueToValidate: string): boolean => {
        const isValid = valueToValidate === "" || validateUrlString(valueToValidate);

        const error = isValid ? "" : translate("si.management.integration.signals-api.section.webhook.url-error");

        setLocalError(error);
        onErrorChange(error || null, index, name);

        return isValid;
    };

    const handleChange = (newValue: string) => {
        setLocalValue(newValue);

        if (validated) {
            validate(newValue);
        }
    };

    const handleBlur = () => {
        setValidated(true);

        if (validate(localValue) && localValue !== value) {
            onChange(index, name, localValue);
        }
    };

    return (
        <InputCell
            {...props}
            error={localError}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};

export default URLInputCell;
